import React from 'react';
import { object, string } from 'yup';
import { cloneDeep } from 'lodash';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormResource from './FormResource.jsx';

const schema = object({
  orgId: string().matches(/^(?:\d+,?)+$/, 'Invalid Organization ID Format'),
});

const defaults = {
  name: '',
  designs: [],
  orgIds: '',
  photos: [],
  description: '',
};

const FormCollection = ({ collection }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: collection && {
        ...collection,
        orgIds: collection.orgIds?.join?.(',') ?? collection.orgIds,
      },
      api: '/api/core/collections',
      onSubmit: (v) => {
        const form = cloneDeep(v);
        const orgIds = form.orgIds
          .split(',')
          .map((x) => parseInt(x.trim(), 10))
          .filter(Boolean);
        form.orgIds = [...new Set(orgIds)];
        return form;
      },
    }}>
    <div className="row">
      <div className="col">
        <FormGroup name="name" label="Collection" />
      </div>
      <div className="col">
        <FormGroup name="orgIds" label="Organization ID (Comma separated)" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup
          name="photos"
          as="slider"
          api="/api/core/collections/files"
          label="Photos"
          gridClassName="col-3 my-3"
          slideClassName="file-slide-contain square"
        />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup
          name="description"
          as="summernote"
          options={{
            styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6'],
            toolbar: [
              ['style', ['style']],
              ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
              ['view', ['codeview', 'undo', 'redo']],
              ['para', ['paragraph']],
            ],
          }}
        />
      </div>
    </div>
  </FormResource>
);

export default FormCollection;
